import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullScreenDataContainer from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';

import { useOnboardingContext } from '../Contexts/OnboardingContext';
import OnboardingHasUserContent from './OnboardingHasUserContent';

const styles = () => ({
  root: {},
});

const OnboardingHasUserContainer = ({
  className,
  classes,
}) => {
  const {
    isInitializing,
  } = useOnboardingContext();

  return (
    <FullScreenDataContainer
      className={classes.container}
      component={OnboardingHasUserContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
    />
  );
};

OnboardingHasUserContainer.defaultProps = {
  className: '',
};

OnboardingHasUserContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingHasUserContainer);
